import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=fc0d2e5c&scoped=true&"
import script from "./CheckComponent.vue?vue&type=script&lang=js&"
export * from "./CheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckComponent.vue?vue&type=style&index=0&id=fc0d2e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0d2e5c",
  null
  
)

export default component.exports